import { render, staticRenderFns } from "./PosServerOptions.vue?vue&type=template&id=1f43d0fe"
import script from "./PosServerOptions.vue?vue&type=script&lang=js"
export * from "./PosServerOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports